import { ApiEndpointSection, ApiMethod } from '../types';

export const apiMethods: ApiMethod[] = [
  { method: 'POST /signal/new', description: 'регистрация рыночного сигнала.' },
  { method: 'POST /signal/limit', description: 'регистрация лимитного сигнала.' },
  { method: 'POST /signal/multiple', description: 'регистрация пакетной заявки.' },
  { method: 'POST /signal/limitmultiple', description: 'регистрация пакетной лимитной заявки.' },
  { method: 'POST /signal/construct', description: 'регистрация портфельного сигнала.' },
  { method: 'POST /signal/externaldelayed', description: 'регистрация отложенного сигнала от автора.' },
  { method: 'DELETE /signal/delayed/{signalId}', description: 'снятие ранее зарегистрированного отложенного сигнала.' },
  { method: 'POST /strategies/portfolio/{strategyId}', description: 'получение текущего состава портфеля.' },
  {
    method: 'POST /strategies/delayedsignals/{strategyId}',
    description: 'получение списка действующих отложенных сигналов по стратегии.',
  },
  { method: 'POST /securities/info', description: 'получение информации по инструменту.' },
];

export const apiExamples = {
  contentType: `Content-type: application/json; charset=UTF-8`,
};

export const apiSections: ApiEndpointSection[] = [
  {
    title: 'Рыночный сигнал',
    request: 'POST /signal/new',
    summary: 'Регистрация сигнала от автора.',
    headers: `apiKey: уникальный ключ по стратегии (string)`,
    body: `{
 strategyId: Guid,  // идентификатор стратегии
 symbol:string,     // тикер
 classCode:string,  // торговая площадка
 board:string,      // всегда 'QUIK'
 weight:decimal,    // вес в %
 comment:string,    // [опционально] комментарий к сигналу
 stopLoss:decimal,  // [опционально]
 takeProfit:decimal // [опционально]
}`,
    response: `{
  "success": bool, // успешно ли выполнение
  "errorMessage": string,
  "errorCode": int,
  "result": // заполняется если success = true
  {
    "currentBalance": decimal,  // текущий баланс с учетом реализованного и не реализованного PnL
    "realizedPnL": decimal,     // реализованный PnL
    "activeCost": decimal,      // текущая стоимость активов в открытых позициях
    "unrealizedPnl": decimal,   // не реализованный PnL
    "activePositions":          // открытые позиции
    {
      "GAZP TQBR QUIK":         // ключ инструмента
      {
        "security":
        {
          "symbol": string,           // тикер
          "classCode": string,        // торговая площадка
          "board": string,            // всегда 'QUIK'
          "key": string               // ключ инструмента
        },
        "weight": decimal,            // вес инструмента (вес входа)
        "openTime": DateTime,         // время открытия
        "closeTime": DateTime,        // время закрытия (опционально)
        "openPrice": decimal,         // цена открытия инструмента
        "openQuotation": decimal,     // котировка открытия инструмента
        "currentPrice": decimal,      // текущая цена инструмента
        "currentQuotation": decimal,  // текущая котировка инструмента
        "realizedPnl": decimal,       // реализованный PnL
        "lastClearingPrice": decimal, // цена последнего клиринга (для фьючерсов)
        "comment": null,              // комментарии к позиции
        "stopLoss": null,             // цена stopLoss (decimal опционально)
        "takeProfit": null,           // цена takeProfit (decimal опционально)
        "unrealizedPnl": decimal,     // не реализованный PnL
        "currentWeight": null         // текущий вес позиции (decimal опционально)
      }
    }
  }
}`,
  },
  {
    title: 'Отложенный сигнал',
    request: 'POST /signal/externaldelayed',
    summary: 'Регистрация отложенного сигнала от автора.',
    body: `{
 apiKey:string         // уникальный ключ по стратегии
 strategyId: Guid,     // идентификатор стратегии
 symbol:string,        // тикер
 classCode:string,     // торговая площадка
 board:string,         // всегда 'QUIK'
 weight:decimal,       // вес в долях, 1=100%
 execQuotation:decimal,// котировка исполнения сигнала
 timeout:decimal,      // время действия лимитной заявки в минутах (не менее 1 и не более 40 минут)
 comment:string,       // [опционально] комментарий к сигналу
 stopLoss:decimal,     // [опционально] уровень stopLoss для итоговой позиции
 takeProfit:decimal    // [опционально]
}`,
    response: `{
 success:bool, // успешно ли выполнение
 errorMessage:string,
 errorCode:int,
 result:
  {
   id:int,               // идентификатор сигнала
   symbol:string,        // тикер инструмента
   name:string,          // название инструмента
   weight:decimal,       // вес сигнала в долях, 1=100%
   fillingTime:DateTime, // время регистрации отложенного сигнала
   execPrice:decimal,    // котировка исполнения сигнала
   currentPrice:decimal, // текущая котировка
   comment:string,       // комментарий к сигналу
   stopLoss:decimal,
   takeProfit:decimal
  }
}`,
  },
  {
    title: 'Лимитный сигнал',
    request: 'POST /signal/limit',
    summary: 'Регистрация лимитного сигнала от автора.',
    headers: `apiKey: уникальный ключ по стратегии (string)`,
    body: `{
 strategyId: Guid,   // идентификатор стратегии
 symbol:string,      // тикер
 classCode:string,   // торговая площадка
 board:string,       // всегда 'QUIK'
 weight:decimal,     // вес в %
 comment:string,     // [опционально] комментарий к сигналу
 stopLoss:decimal,   // [опционально]
 takeProfit:decimal, // [опционально]
 price:decimal,      // цена сигнала
 timeout:decimal     // время действия лимитной заявки в минутах
}`,
    response: `{
  "success": bool,
  "errorMessage": string,
  "errorCode": int,
  "result":
  {
    "currentBalance": decimal,
    "realizedPnL": decimal,
    "activeCost": decimal,
    "unrealizedPnl": decimal,
    "activePositions":
    {
      "GAZP TQBR QUIK":
      {
        "security":
        {
          "symbol": string,
          "classCode": string,
          "board": string,
          "key": string
        },
        "weight": decimal,
        "openTime": DateTime,
        "closeTime": DateTime,
        "openPrice": decimal,
        "openQuotation": decimal,
        "currentPrice": decimal,
        "currentQuotation": decimal,
        "realizedPnl": decimal,
        "lastClearingPrice": decimal,
        "comment": null,
        "stopLoss": null,
        "takeProfit": null,
        "unrealizedPnl": decimal,
        "currentWeight": null
      }
    }
  }
}`,
  },
  {
    title: 'Отмена активного лимитного сигнала',
    request: 'POST /signal/limitcancel',
    summary: 'Отмена текущего активного лимитного сигнала.',
    headers: `apiKey: уникальный ключ по стратегии (string)`,
    body: `{
  "strategyId": Guid // идентификатор стратегии
}`,
    response: `{
  "success": bool, // успешно ли выполнение
  "errorMessage": "string",
  "errorCode": int
}`,
  },
  {
    title: 'Пакетная заявка',
    request: 'POST /signal/multiple',
    summary: 'Регистрация пакетной заявки.',
    headers: `apiKey: уникальный ключ по стратегии (string)`,
    body: `[
 {
  strategyId: Guid,  // идентификатор стратегии
  symbol:string,     // тикер
  classCode:string,  // торговая площадка
  board:string,      // всегда 'QUIK'
  weight:decimal,    // вес в %
  comment:string,    // [опционально] комментарий к сигналу
  stopLoss:decimal,  // [опционально]
  takeProfit:decimal // [опционально]
 },
 ...
]`,
    response: `{
  "success": bool,  // true если запрос выполнен успешно
  "errorMessage": string,
  "errorCode": int
}`,
  },
  {
    title: 'Пакетная лимитная заявка',
    request: 'POST /signal/limitmultiple',
    summary: 'Регистрация пакетной лимитной заявки.',
    headers: `apiKey: уникальный ключ по стратегии (string)`,
    body: `{
 strategyId: Guid,   // идентификатор стратегии
 symbol:string,      // тикер
 classCode:string,   // торговая площадка
 board:string,       // всегда "QUIK"
 weight:decimal,     // вес в %
 comment:string,     // [опционально] комментарий к сигналу
 stopLoss:decimal,   // [опционально]
 takeProfit:decimal, // [опционально]
 price:decimal,      // цена сигнала
 timeout:decimal     // время действия лимитной заявки в минутах
}`,
    response: `200 OK с пустым телом`,
  },
  {
    title: 'Портфельный сигнал',
    request: 'POST /signal/construct',
    summary: 'Регистрация портфельного сигнала.',
    headers: `apiKey: уникальный ключ по стратегии (string)`,
    body: `{
 stratId: Guid, // идентификатор стратегии
 positions:
 [
  {
    securityKey:string, // ключ бумаги в формате "{Symbol} {ClassCode} QUIK"
    weight:decimal,     // вес в %
    comment:string,     // [опционально] комментарий к сигналу
    stopLoss:decimal,   // [опционально]
    takeProfit:decimal  // [опционально]
  }
 ]
}`,
    response: `{
  "success": bool,  // true если запрос выполнен успешно
  "errorMessage": string,
  "errorCode": int
}`,
  },
  {
    title: 'Получение состава портфеля',
    request: 'POST /strategies/portfolio/{strategyId}',
    summary: 'Запрос текущего состава портфеля.',
    body: `{
 apiKey: string // уникальный ключ по стратегии
}`,
    response: `{
  "result": {
    "currency": string,         // валюта портфеля
    "portfolioWeight": decimal, // доля позиций в портфеле
    "currentFree": decimal,     // доля свободных средств
    "relizedPL": decimal,       // реализованный PnL
    "unrealizedPL": decimal,    // не реализованный PnL
    "currentBalance": decimal,  // текущий баланс
    "positions": [
      {
        "security": string,    // инструмент
        "avgPrice": decimal,   // средневзвешенная цена покупки
        "realizedPnl": decimal,// реализованный PnL по позиции
        "weight": decimal      // текущий вес позиции
      },
      ...
    ]
  },
  "success": bool,
  "errorMessage": string,
  "errorCode": int
}`,
  },
  {
    title: 'Список действующих отложенных сигналов по стратегии',
    request: 'POST /strategies/delayedsignals/{strategyId}',
    summary: 'Список действующих отложенных сигналов по стратегии.',
    headers: 'apiKey: уникальный ключ по стратегии (string)',
    body: `{
  "PageSize": int,          // максимальное количество заявок, возвращаемое в ответе
  "PageNumber": int,        // номер порции данных
  "SortFieldName": string,  // название поля, по которому сортируются полученные данные
  "SortDirection": int,     // порядок сортировки: > 0 - по возрастанию, <= 0 - по убыванию
  }
  "`,
    response: `{
  "result": {
    "TotalSignals": int,      // общее количество активных сигналов
    "PageSignals": [
      {
        "Id": long,             // ID сигнала
        "Symbol": string,       // тикер инструмента, по которому подан сигнал
        "Name": string,         // Наименование инструмента
        "FillingTime": string,  // дата-время создания заявки
        "Weight": string,       // вес в процентах для стратегии
        "OpenPrice": string,    // цена
        "ExecPrice": string,    // цена исполнения
        "Direction": int,       // покупка/продажа
        "CurrentPrice": string, // текущая цена
        "StopLoss": string,
        "TakeProfit": string,
        "Comment": string,      // комментарий
        "Type": string,         // тип сигнала
      },
      ...
    ]
  },
  "success": bool,    // true если запрос выполнен успешно
  "errorMessage": string,
  "errorCode": int
}`,
  },
  {
    title: 'Информация по инструменту',
    request: 'POST /securities/info',
    summary: 'Информация по инструменту.',
    body: `{
  "apiKey": string,    // ключ Api
  "strategyId": Guid,  // id стратегии
  "securityKey": string // инструмент
}`,
    response: `{
  "result": {
    "type": string,         // тип инструмента
    "lotSize": int,         // лотность
    "price": decimal,       // цена инструмента
    "quotation": decimal,   // котировка инструмента
    "currency": string,     // валюта
    "shortAllowed": bool,   // разрешен ли шорт
    "minWeight": decimal,   // мин вес в процентах для стратегии
    "maxWeight": decimal,   // макс вес в процентах для стратегии
    "currentWeight": decimal,// текущий вес в портфеле стратегии
    "maxSLBuy": decimal,    // макс/мин значения SL/TP для продажи/покупки
    "minTPBuy": decimal,
    "minSLSell": decimal,
    "maxTPSell": decimal,
    "priceDigits": int,     // количество цифр после запятой для цены
    "key": string,          // инструмент
    "symbol": string,       // тикер
    "classCode": string,    // торговая площадка
    "name": string,         // название инструмента
    "board": "QUIK"
  },
  "success": bool,
  "errorMessage": string,
  "errorCode": int
}`,
  },
  {
    title: 'Снятие отложенного сигнала',
    request: 'DELETE /signal/delayed/{signalId}',
    summary: 'Снятие ранее зарегистрированного отложенного сигнала.',
    response: `{
  "success": bool,
  "errorMessage": string,
  "errorCode": int
}`,
  },
];
